import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index.ts';

export const selectContributionsStatus = createSelector(
  [
    (state: RootState) => state.mainMenu.areContributionsEnabled,
    (state: RootState) => state.mainMenu.areContributionsLoading
  ],
  (areContributionsEnabled, areContributionsLoading) => ({
    areContributionsEnabled,
    areContributionsLoading
  })
);

export const selectDisabilitiesStatus = createSelector(
  [
    (state: RootState) => state.mainMenu.areDisabilitiesEnabled,
    (state: RootState) => state.mainMenu.areDisabilitiesLoading
  ],
  (areDisabilitiesEnabled, areDisabilitiesLoading) => ({
    areDisabilitiesEnabled,
    areDisabilitiesLoading
  })
);
